'use client';

import { usePlansQuery } from '../api/billingApi';

/** Plan catalog + provider availability flags from `/billing/plans`. */
export function usePlans() {
  return usePlansQuery();
}
